<template>
  <div class="content followTest">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="followTest">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i>跟踪测试
        </span>
        <div class="normalNav zaddBtn">
          <button class="BlueSmBtn" @click="confirmSearch">跟踪</button>
          <button class="OrangeSmBtn" @click="resetSearch">重置</button>
        </div>
        <div class="searchForm1">
          <el-form class="searchForm" :model="searchForm" :rules="searchFormRules" ref="searchForm">
            <el-form-item label="应用系统" prop="systemId">
              <el-select :popper-append-to-body="false" v-model="searchForm.systemId" placeholder="请选择应用系统" @change="selectSystem">
                <el-option v-for="sys in systemList" :label="sys.name" :key="sys.id" :value="sys.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="设备类型" prop="deviceType">
              <el-select :popper-append-to-body="false" v-model="searchForm.deviceType" placeholder="请选择设备类型">
                <el-option v-for="type in deviceTypeList" :label="type.typeName" :key="type.id" :value="type.id" />
              </el-select>
            </el-form-item>
            <el-form-item label="设备" prop="deviceName">
              <el-input v-model="searchForm.deviceName" placeholder="请选择设备" @focus="initDeviceBox" readonly />
            </el-form-item>
          </el-form>
        </div>
        <div class="detailContent">
          <div class="leftContent">
            <div class="messages">
              <template v-if="messageList.length">
                <div class="messageList" v-for="(item,index) in messageList" :key="index" @click="selectMessage(index)" :class="{'selected': currentSelect === index }">序号{{ index + 1}}</div>
              </template>
              <template v-else>
                <div class="noText">暂无数据</div>
              </template>
            </div>
            <div class="rightsInfo">
              <div class="messageNode">
                <template v-if="currentSelect !== undefined">
                  <div class="nodeItem" :class="{'selectedNode': currentSelectNode === 'gw' }" @click="selectNode('gw')">gw</div>
                  <div class="nodeArrow">—></div>
                  <div class="nodeItem" :class="{'selectedNode': currentSelectNode === 'datahandle' }" @click="selectNode('datahandle')">datahandle</div>
                  <div class="nodeArrow">—></div>
                  <div class="nodeItem" :class="{'selectedNode': currentSelectNode === 'operation' }" @click="selectNode('operation')">operation</div>
                  <div class="nodeArrow">—></div>
                  <div class="nodeItem" :class="{'selectedNode': currentSelectNode === 'taos' }" @click="selectNode('taos')">taos</div>
                </template>
                <template v-else>暂未选择</template>
              </div>
              <div class="messageContent">{{ nodeContent }}</div>
            </div>
          </div>
          <div class="rightContent">
            <div class="contents">
              <el-row>
                <el-radio-group v-model="mode" @change="changePostMode">
                  <el-radio label="TCP">TCP</el-radio>
                  <el-radio label="UDP">UDP</el-radio>
                  <el-radio label="HTTP">HTTP</el-radio>
                </el-radio-group>
              </el-row>
              <el-form :model="postForm" inline style="margin-top: 40px" v-if="mode !== 'HTTP'" :rules="postFormRule" ref="postForm" key="hasPort">
                <el-form-item label="地址" prop="address">
                  <el-input v-model="postForm.address" placeholder="请输入地址" style="width: 250px;" />
                </el-form-item>
                <el-form-item label="端口" prop="port">
                  <el-input v-model="postForm.port" placeholder="请输入端口号" type="number" style="width: 150px;" />
                </el-form-item>
              </el-form>
              <el-form :model="postForm" inline style="margin-top: 40px" v-else :rules="postFormRule" ref="postForm" key="noPort">
                <el-form-item label="地址" prop="address">
                  <el-input v-model="postForm.address" placeholder="请输入地址" style="width: 450px;" />
                </el-form-item>
              </el-form>
              <el-input :rows="12" v-model="postForm.content" placeholder="请输入报文内容" type="textarea"></el-input>
              <p style="margin-top: 30px; width: 100%; text-align: center; padding: 0 30px;">
                <button class="w_next_button cancelButton" @click="clearPostContent">清空</button>
                <button class="w_next_button confirmButton" @click="sendMessage">发送</button>
              </p>
            </div>
          </div>
        </div>
      </el-tab-pane>
    </el-tabs>
    <el-dialog title="设备列表" class="deviceDialog" :visible.sync="deviceBoxShow" inline>
      <div v-if="deviceList.length" class="full">
        <p><span>操作</span><span>设备名称</span><span>设备编码</span><span>设备状态</span></p>
        <p v-for="(dv, index) in deviceList" :key="index">
          <span @click="selectDevice(dv.deviceId)">
            <i :class="['checkbox', selectDeviceId === dv.deviceId ? 'selected' : '']"></i>
          </span>
          <span>{{ dv.deviceName }}</span>
          <span>{{ dv.deviceId }}</span>
          <span>{{ dv.deviceStatusName }}</span>
        </p>
      </div>
      <div v-else class="empty">暂无数据</div>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="deviceBoxShow = false">取 消</el-button>
        <el-button size="small" type="primary" @click="confirmSelectDevice">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      tabName: 'followTest',
      searchForm: {
        systemId: undefined,
        deviceType: undefined,
        deviceId: undefined,
        deviceName: undefined,
      },
      searchFormRules: {
        deviceName: [{ required: true, message: '请选择设备', trigger: 'change' }],
      },
      // 应用系统列表
      systemList: [],
      // 设备类型全列表
      deviceTypeAllList: [],
      // 当前设备类型列表
      deviceTypeList: [],
      // 可选择设备列表
      deviceList: [],
      // 设备列表展现
      deviceBoxShow: false,
      // 选中设备编码
      selectDeviceId: undefined,
      mode: 'TCP',
      postForm: {
        address: undefined,
        port: undefined,
        content: undefined,
      },
      postFormRule: {
        address: [{ required: true, message: '请输入地址', trigger: 'blur' }],
        port: [{ required: true, message: '请输入端口号', trigger: 'blur' }],
      },
      websock: null,
      heartTimer: null, //心跳定时器
      lockReconnect: false, //是否真正建立连接
      reconnectTimeOut: null, //断开 重连倒计时
      isClickReconnect: false, //
      arrList: [],
      messageList: [],
      currentSelect: undefined,
      currentMessageList: [],
      currentSelectNode: undefined,
      nodeContent: '',
    }
  },
  mounted() {
    this.initSystemList()
  },
  methods: {
    initSystemList() {
      this.$axiosget('manager/operatingSystemApi/getOperatingSystemsByCompanyId', {
        params: {
          compayId: localStorage.getItem('companyId'),
        },
      }).then((res) => {
        this.systemList = res.data.data || []
      })
    },
    selectSystem(systemId) {
      this.searchForm.deviceType = undefined
      this.searchForm.deviceId = undefined
      this.searchForm.deviceName = undefined
      this.selectDeviceId = undefined
      this.deviceTypeList = []
      this.dataFlowList = []
      this.deviceList = []
      let tempDeviceTypeList = this.deviceTypeAllList.filter((it) => it.systemId === systemId)
      if (tempDeviceTypeList.length) {
        this.deviceTypeList = tempDeviceTypeList
      } else {
        this.$axiosget('manager/operatingSystemApi/getDeviceTypeByOperatingId', {
          params: {
            id: systemId,
          },
        }).then((res) => {
          let temp = res.data.data || []
          temp.forEach((t) => {
            let { id, typeName } = t
            this.deviceTypeList.push({
              id,
              typeName,
              systemId,
            })
          })
          this.deviceTypeAllList = this.deviceTypeAllList.concat(this.deviceTypeList)
        })
      }
    },
    selectDeviceType() {
      this.searchForm.dataFlow = undefined
      this.searchForm.deviceId = undefined
      this.searchForm.deviceName = undefined
      this.selectDeviceId = undefined
      this.deviceList = []
    },
    initDeviceBox() {
      this.selectDeviceId = undefined
      this.searchForm.deviceId = undefined
      this.searchForm.deviceName = undefined
      this.deviceList = []
      if (!this.searchForm.systemId || !this.searchForm.deviceType) {
        this.$message.warning('请先选择应用系统或设备类型')
        this.deviceBoxShow = false
      } else {
        Promise.resolve().then(() => {
          this.queryDeviceList()
          this.deviceBoxShow = true
        })
      }
    },
    queryDeviceList() {
      this.$axiosget('operation/device/list', {
        params: {
          system_id: this.searchForm.systemId,
          deviceType: this.searchForm.deviceType,
        },
      }).then((res) => {
        this.deviceList = res.data.data.deviceList || []
      })
    },
    selectDevice(deviceId) {
      this.selectDeviceId = this.selectDeviceId === deviceId ? undefined : deviceId
    },
    confirmSelectDevice() {
      if (!this.selectDeviceId) {
        this.$message.warning('未选择设备！')
      } else {
        this.searchForm.deviceName = this.deviceList.find((it) => it.deviceId === this.selectDeviceId).deviceName || undefined
        this.searchForm.deviceId = this.selectDeviceId
        this.deviceBoxShow = false
      }
    },
    confirmSearch() {
      this.isClickReconnect = false
      this.$refs.searchForm.validate((valid) => {
        if (valid) {
          this.initWebSocket()
          this.$message.success('跟踪开始')
        }
      })
    },
    initWebSocket() {
      let compayId = localStorage.getItem('companyId')
      let wsUri = ''
      if (process.env.NODE_ENV === 'development') {
        wsUri =
          process.env.SSL_HOST.indexOf('https') != -1
            ? `wss://${process.env.SSL_HOST.replace(/^https?\:\/\//i, '')}/simulationSocket/${this.searchForm.deviceId}/${compayId}`
            : `ws://${process.env.SSL_HOST.replace(/^https?\:\/\//i, '')}/simulationSocket/${this.searchForm.deviceId}/${compayId}`
      } else {
        wsUri =
          process.env.SSL_ENABLE || process.env.SSL_ENABLE === 'true'
            ? `wss://${window.location.host}/simulationSocket/${this.searchForm.deviceId}/${compayId}`
            : `ws://${window.location.host}/simulationSocket/${this.searchForm.deviceId}/${compayId}`
      }
      // 建立连接
      this.websocket = new WebSocket(wsUri)
      // 连接成功
      this.websocket.onopen = this.websocketOnOpen
      // 连接错误
      this.websocket.onerror = this.websocketOnError
      // 接收信息
      this.websocket.onmessage = this.websocketOnMessage
      // 连接关闭
      this.websocket.onclose = this.websocketClose
    },
    // 开启心跳
    start() {
      this.heartTimer && clearInterval(this.heartTimer)
      this.heartTimer = setInterval(() => {
        // 这里发送一个心跳，后端收到后，返回一个心跳消息
        // 如果连接正常
        console.log('发送心跳', this.websocket)
        if (this.websocket.readyState == 1) {
          this.websocket.send(JSON.stringify({ status: 'heartbeat' }))
        }
      }, 40000)
    },
    // 重置心跳
    reset() {
      // 清除时间
      clearInterval(this.heartTimer)
      // 重启心跳
      this.start()
    },
    websocketOnOpen() {
      // 连接成功事件
      console.log('WebSocket连接成功!')
      let data = {
        status: 'request',
        companyId: localStorage.getItem('companyId'),
        deviceId: this.searchForm.deviceId,
      }
      if (this.websocket.readyState == 1) {
        this.websocket.send(JSON.stringify(data))
      }
      // 开启心跳
      this.start()
    },
    websocketOnError(e) {
      // 连接失败事件
      console.log('WebSocket连接发生错误', e)
    },
    websocketOnMessage(event) {
      // 接收服务器推送的信息
      let receiveMsg = JSON.parse(event.data)
      if (Object.keys(receiveMsg).length !== 0) {
        this.arrList.push(receiveMsg)
        Promise.resolve().then(() => {
          this.dealData(this.arrList)
          this.reset()
        })
      }
    },
    dealData() {
      let dealWidthData = function (data) {
        let c = []
        let d = {}
        data.forEach((element) => {
          if (!d[element.id]) {
            c.push({
              id: element.id,
              allData: [element],
            })
            d[element.id] = element
          } else {
            c.forEach((ele) => {
              if (ele.id == element.id) {
                ele.allData.push(element)
              }
            })
          }
        })

        return c
      }
      this.messageList = dealWidthData(this.arrList)
    },
    // 选择某个推送消息展示消息传输的节点
    selectMessage(index) {
      this.currentSelect = index
      this.currentMessageList = this.messageList[index].allData
      this.currentSelectNode = ''
      this.nodeContent = ''
    },
    // 选择消息传输节点展示消息的内容
    selectNode(name) {
      this.currentSelectNode = name
      this.currentMessageList.forEach((item) => {
        if (JSON.parse(item.playloadJson).moduleName === name) {
          this.nodeContent = JSON.parse(item.playloadJson).content
        }
      })
    },
    websocketClose(e) {
      console.log('链接断开')
      this.reconnect()
    },
    // 重连
    reconnect() {
      if (this.lockReconnect && !this.isClickReconnect) {
        return
      }
      this.lockReconnect = true
      // 没连接上会一直重连，设置延迟避免请求过多
      this.reconnectTimeOut && clearTimeout(this.reconnectTimeOut)
      this.reconnectTimeOut = setTimeout(() => {
        this.websocket = null
        // 新连接
        this.initWebSocket()
        this.lockReconnect = false
      }, 5000)
    },
    // 重置查询
    resetSearch() {
      this.websocket = null
      this.isClickReconnect = true
      this.arrList = []
      this.messageList = []
      this.currentSelect = undefined
      this.currentMessageList = []
      this.nodeContent = ''
      this.$refs.searchForm.resetFields()
      this.searchForm.deviceId = undefined
      this.clearPostContent()
      clearInterval(this.heartTimer)
      this.mode = 'TCP'
    },
    changePostMode() {
      this.$refs.postForm.resetFields()
      this.postForm.address = undefined
      this.postForm.port = undefined
    },
    // 发送消息
    sendMessage() {
      if (this.websocket === null) {
        this.$message.error('请先跟踪设备')
        return
      }
      if (!this.postForm.content) {
        this.$message.error('请输入报文内容')
        return
      }
      this.$refs.postForm.validate((valid) => {
        if (valid) {
          if (this.mode === 'TCP' || this.mode === 'UDP') {
            let data = {
              status: this.mode,
              ip: this.postForm.address,
              port: this.postForm.port,
              message: this.postForm.content,
            }
            if (this.websocket.readyState == 1) {
              this.websocket.send(JSON.stringify(data))
              this.$message.success('发送成功')
            }
          } else {
            let data = {
              status: this.mode,
              url: this.postForm.address,
              message: this.postForm.content.replace(/\r\n/g, ''),
            }
            if (this.websocket.readyState == 1) {
              this.websocket.send(JSON.stringify(data))
              this.$message.success('发送成功')
            }
          }
        }
      })
    },
    clearPostContent() {
      this.$refs.postForm.resetFields()
      this.postForm.address = undefined
      this.postForm.port = undefined
      this.postForm.content = undefined
    },
  },
  destroyed() {
    this.websocket = null
    clearInterval(this.heartTimer)
  },
}
</script>

<style lang="less">
.followTest .el-tabs,
.followTest .el-tabs .content,
.followTest .el-tabs .el-tabs__content .el-tab-pane {
  height: 100%;
  box-shadow: none;
}
.followTest .el-tabs .el-tabs__content {
  height: calc(100% - 52px);
  box-shadow: none;
}

.followTest {
  height: calc(100% - 36px);
  padding: 0 0 20px 0;
}
</style>

<style lang="less" scoped>
.detailContent {
  height: calc(100% - 73px);
  background-color: #181c2e;
  display: flex;
  padding: 20px 20px 10px;

  .leftContent {
    flex: 1;
    background-color: #232944;
    height: 100%;
    padding: 20px 30px;
    display: flex;

    .messages {
      width: 200px;
      height: 100%;
      overflow: auto;
      .messageList {
        width: 100%;
        height: 42px;
        text-align: center;
        line-height: 42px;
        background: #181c2e;
        font-size: 14px;
        color: #c3c3c3;
        border-bottom: 1px solid #464958;

        &:hover {
          background: #142643db;
          cursor: pointer;
        }
      }

      .noText {
        width: 100%;
        height: 100%;
        display: flex;
        justify-content: center;
        align-items: center;
        color: #c3c3c3;
      }

      .selected {
        background: #142643db;
      }
    }

    .rightsInfo {
      width: 100%;
      padding-left: 20px;

      & > div {
        height: 49%;
        background: rgba(24, 28, 46, 0.9);
        border: 1px solid #263046;
        color: #fff;

        &:first-child {
          margin-bottom: 1.2%;
        }
      }

      .messageNode {
        display: flex;
        justify-content: center;
        align-items: center;

        .nodeItem {
          width: 120px;
          height: 120px;
          background: #2e3657;
          border-radius: 50%;
          display: flex;
          justify-content: center;
          align-items: center;
          font-size: 14px;
          color: #fff;
          cursor: pointer;

          &:hover {
            background: #262d4a;
          }
        }

        .selectedNode {
          background: #262d4a;
        }

        .nodeArrow {
          font-size: 28px;
        }
      }

      .messageContent {
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 14px;
        color: #fff;
      }
    }
  }

  .rightContent {
    width: 680px;
    height: 100%;
    background-color: #232944;
    padding: 20px 30px 20px 0;

    .contents {
      height: 100%;
      background: rgba(24, 28, 46, 0.9);
      border: 1px solid #263046;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;

      /deep/ .el-textarea__inner {
        margin: 50px 30px 0;
        background-color: #2e3657;
        border-color: rgba(221, 221, 221, 0.2);
        color: #f5f5f5;
        border-radius: 0;
        width: 91%;
      }

      .w_next_button {
        width: 30%;
      }

      .cancelButton {
        margin-right: 30px;
      }
    }
  }
}

.deviceDialog {
  /deep/ .el-dialog__body {
    .full {
      p {
        min-height: 36px;
        line-height: 36px;
        display: flex;
        flex-flow: row nowrap;
        border-top: 1px solid rgba(221, 221, 221, 0.2);
        justify-content: space-evenly;
        color: #ccc;
        font-size: 14px;
        border-radius: 2px;
        span {
          min-width: 100px;
          cursor: pointer;
          width: 39%;
          text-align: center;
          .checkbox {
            width: 14px;
            height: 14px;
            display: inline-block;
            margin: 0 auto;
            background: #ccc;
            border-radius: 4px;
          }
          .checkbox.selected {
            background: #00a7ff;
          }
        }
        span:first-child {
          width: 10%;
        }
        span:last-child {
          width: 12%;
        }
      }
      p:nth-child(2n - 1) {
        background: rgba(46, 54, 87, 0.32);
      }
      p:first-child {
        background: rgba(46, 54, 87, 0.92) !important;
      }
      p:hover {
        background: rgba(46, 54, 87, 0.72) !important;
      }
    }
    .empty {
      min-height: 36px;
      line-height: 36px;
      color: #ccc;
      text-align: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute2/systemConfiguration/first/ToolManagement/followTest/index.vue